import React from 'react';
import NewApplicationPage from './NewApplicationPage';
import {
    AdditionalProfiCardApplication,
    createEmptyAdditionalProfiCardDeApplication
} from '../../domain/application/profiCard/additional/model';
import {
    AdditionalProfiCardApplicationForm
} from '../../domain/application/profiCard/additional/AdditionalProfiCardApplicationForm';

export default function NewAdditionalProfiCardDeApplicationPage() {
    return (<NewApplicationPage<AdditionalProfiCardApplication>
            renderApplicationForm={AdditionalProfiCardApplicationForm}
            createEmptyApplication={createEmptyAdditionalProfiCardDeApplication}/>);
}

